<template> 
  <b-form @submit.stop.prevent="submit">
    <b-form-group label="Title">
      <b-form-input v-model="form.title" required></b-form-input>
    </b-form-group>

    <div class="row">
      <div class="col">
        <b-form-group label="Key">
          <b-form-input v-model="form.key"></b-form-input>
        </b-form-group>
      </div>

      <div class="col">
        <b-form-group label="Author">
          <b-form-input v-model="form.author"></b-form-input>
        </b-form-group>
      </div>
    </div>
  
    <b-form-group label="Body">
      <b-form-textarea v-model="form.body" rows="10" required></b-form-textarea>
    </b-form-group>  

    <div class="d-flex flex-row-reverse">
      <b-button type="submit" variant="primary">Save</b-button>
    </div>
  </b-form>
</template>

<script>
  import gql from 'graphql-tag'

  const CREATE_SONG = gql`
    mutation CreateSong($input: songs_insert_input!) {
      song: insert_songs_one(object: $input) {
        id
        title
        body
        key
        author
        created_at
        updated_at
      }
    }
  `;

  const UPDATE_SONG = gql`
    mutation UpdateSong($id: uuid!, $input: songs_set_input!) {
      song: update_songs_by_pk(
        pk_columns: { id: $id },
        _set: $input
      ) {
        id
        title
        body
        key
        author
        created_at
        updated_at
      }
    }
  `;

  export default {
    props: ['id', 'song'],

    data() {
      return {
        form: this.initForm(),
      }
    },

    watch: {
      form: {
        handler() {
          this.$emit('changed');
        },

        deep: true
      }
    },

    methods: {
      initForm() {
        return {
          title: this.song && this.song.title,
          body: this.song && this.song.body || '',
          key: this.song && this.song.key,
          author: this.song && this.song.author
        }
      },

      submit() {
        if (this.song) {
          this.update();
        } else {
          this.create();
        }
      },

      create() {
        this.$apollo.mutate({
          mutation: CREATE_SONG,

          variables: {
            input: this.form
          },

          update: (cache, { data }) => {
            this.form = this.initForm();
            this.$emit('saved', data.song, { cache });
          }
        })
      },

      update() {
        const id = this.$props.song.id;
        
        this.$apollo.mutate({
          mutation: UPDATE_SONG,

          variables: {
            id,
            input: this.form
          }
        }).then(({ data }) => {
          this.$emit('saved', data.song, {})
        })
      }
    }
  }
</script>

<style>
  @import '~@sum.cumo/vue-datepicker/dist/Datepicker.css';

  .editor {
    height: 250px;
  }

  .full:fullscreen .editor {
    height: calc(100vh - 4rem);
  }

  .full {
    padding: 1rem 0;
  }

  .full:fullscreen {
    background: #fff;
    padding: 1rem;
  }
</style>